module.exports = __webpack_public_path__ + "static/img/areaA-11.ab5da56.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/areaA-11.png
// module id = 922
// module chunks = 1